import { filterTypes } from "../constants";
import { isEmpty, map } from "lodash";
import { loadProviders } from "../apis";
import { storedViewPreferences, urlViewPreferences } from "../utils";
import { useProviderPanels } from "../contexts/provider-panels-context";

const preloadProviderFilters = async (values) => {
  const ids = map(values, String);

  if (!ids.length) {
    return [];
  }

  const providers = await loadProviders({ ids }, ids.length);

  return map(providers, ({ id, nameWithCredentials }) => ({ value: parseInt(id), label: nameWithCredentials }));
};

const useViewPreferencesPreloader = () => {
  const { enableStoredPreferences } = useProviderPanels();

  return async () => {
    let viewPreferences = urlViewPreferences();

    if (enableStoredPreferences && isEmpty(viewPreferences.filters) && isEmpty(viewPreferences.pageParams)) {
      viewPreferences = await storedViewPreferences();
    }

    const filters = (await Promise.all(
      Object.entries(viewPreferences.filters).map(async ([key, values]) => {
        switch (key) {
          case filterTypes.PROVIDERS:
            return { [key]: await preloadProviderFilters(map(values, 'value')) };
          case filterTypes.PRACTICES:
          case filterTypes.PROVIDER_LICENSES:
          case filterTypes.STATUSES:
          case filterTypes.PAYMENT_METHODS:
          case filterTypes.ACCEPT_NEW_PATIENTS_STATUS:
            return { [key]: values };
        }
      })
    )).reduce((filter, result) => ({...result, ...filter}), {});

    return {
      pageParams: viewPreferences.pageParams,
      filters
    };
  };
};

export default useViewPreferencesPreloader;
